export default __webpack_public_path__ + "static/media/CV_Jamie_Lee_Hart.04e19337.pdf";